import { render } from "./Trips.vue?vue&type=template&id=4f793df6&scoped=true"
import script from "./Trips.vue?vue&type=script&lang=js"
export * from "./Trips.vue?vue&type=script&lang=js"

import "./Trips.vue?vue&type=style&index=0&id=4f793df6&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f793df6"]])

export default __exports__